import {User} from './user.model';
import {EnumValues} from './enum-values.model';
import {MeansTransportEnum} from '../enums/means-transport.enum';
import {SchoolLevel} from './school-level.model';
import {YoungImageRight} from './young-image-right.model';
import { PDisorderDys } from '../param/p-disorder-dys.model';
import { PSchoolHelp } from '../param/p-school-help.model';
import { PSchoolLevel } from '../param/p-school-level.model';
import { YoungPDifficulteScolaire } from './young-pdifficultescolaire.model';
import { YoungPDisciplineDifficulteScolaire } from './young-pdisciplinedifficultescolaire.model';

export class Young {
    id: number;
    phone: string;
    numberBrother: number;
    numberSister: number;
    handicap: string;
    meansTransport: MeansTransportEnum;
    drivingLicence: boolean;
    drivingLicenceGettingDate: Date;
    childs: number;
    weight: number;
    height: number;
    nationality: string;
    dateUpdate: Date;
    medicalObservation: string;
    idYellowBox: number;
    picturePath: string;
    birthTown: string;
    snap: string;
    isInscritPoleEmploi: boolean;
    isInscritMissionLocale: boolean;
    hasParentIsolated: boolean;
    idEnumValuesOrigin: number;

    idPersonInCharge: number;
    personInCharge: User;
    userYoung: User;
    origin: EnumValues;

    listOfSchoolLevel: SchoolLevel[];
    youngImageRights: YoungImageRight[];

    schoolLevelRepeateds: PSchoolLevel[];
    disorderDys: PDisorderDys[];
    schoolHelps: PSchoolHelp[];

    listOfYoungPDifficulteScolaire: YoungPDifficulteScolaire[];
    listOfYoungPDisciplineDifficulteScolaire: YoungPDisciplineDifficulteScolaire[];

    constructor() {
        this.numberBrother = 0;
        this.numberSister = 0;
    }
}
